import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "messagesContainer",
    "input",
    "form",
    "submitButton",
    "submitIcon",
    "submitSpinner",
    "loadingIndicator"
  ];

  static values = {
    conversationId: Number
  };

  connect() {
    this.waitingForResponse = false;
    this.scrollToBottom();
    this.setupMutationObserver();
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupMutationObserver() {
    if (!this.hasMessagesContainerTarget) return;

    this.observer = new MutationObserver((mutations) => {
      this.scrollToBottom();

      // Check if an assistant message was added
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.classList &&
            node.classList.contains("message-assistant")
          ) {
            // Assistant message received - clear loading state
            this.setLoadingState(false);
            this.focusInput();
          }
        });
      });
    });

    this.observer.observe(this.messagesContainerTarget, {
      childList: true,
      subtree: true
    });
  }

  submitStart() {
    this.setLoadingState(true);
  }

  submitEnd() {
    // Clear input after submission
    if (this.hasInputTarget) {
      this.inputTarget.value = "";
    }
    // Keep loading state - will be cleared when assistant responds
  }

  setLoadingState(isLoading) {
    this.waitingForResponse = isLoading;

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = isLoading;
    }

    if (this.hasSubmitIconTarget) {
      this.submitIconTarget.classList.toggle("d-none", isLoading);
    }

    if (this.hasSubmitSpinnerTarget) {
      this.submitSpinnerTarget.classList.toggle("d-none", !isLoading);
    }

    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.toggle("d-none", !isLoading);
    }

    if (this.hasInputTarget) {
      this.inputTarget.disabled = isLoading;
    }
  }

  insertQuestion(event) {
    if (this.waitingForResponse) return;

    const text = event.currentTarget.dataset.questionText;
    if (text && this.hasInputTarget) {
      this.inputTarget.value = text;
      this.focusInput();
    }
  }

  selectOption(event) {
    event.preventDefault();
    if (this.waitingForResponse) return;

    const text = event.currentTarget.dataset.optionText;
    if (text && this.hasInputTarget && this.hasFormTarget) {
      this.inputTarget.value = text;
      this.formTarget.requestSubmit();
    }
  }

  focusInput() {
    if (this.hasInputTarget) {
      this.inputTarget.focus();
    }
  }

  scrollToBottom() {
    if (this.hasMessagesContainerTarget) {
      this.messagesContainerTarget.scrollTop =
        this.messagesContainerTarget.scrollHeight;
    }
  }
}
